/**
 * `GET /portal/usage` のレスポンスを、容量・送信数の画面が扱う形へ変換する。
 *
 * API は「現在値（current）」「上限（limits）」「内訳（perMailbox）」を
 * それぞれ平たい形で返す。画面は「容量の話」と「送信数の話」を別のカードに
 * 分けて出すので、境界でその 2 つに束ね直す。
 *
 * どちらを正にするか: **API の形を正とする**。API 側で `storage` / `sending` に
 * 分けてしまうと、上限値（`limits`）だけがプラン由来で別の出所になり、
 * 「storage.totalBytes と limits.storageBytesTotal のどちらが正か」という
 * 答えの無い問いが生まれる。束ね直しは表示都合なので画面側の責任に置く。
 */
import type { UsageResponse } from './api-types.js';

export interface UsageView {
  storage: {
    usedBytes: number;
    /** 0 は無制限。 */
    totalBytes: number;
    perMailbox: Array<{
      mailboxId: string;
      address: string;
      usedBytes: number;
      quotaBytes: number;
    }>;
  };
  sending: {
    sentToday: number;
    perDayMax: number;
    sentThisMonth: number;
  };
}

export function toUsageView(res: UsageResponse): UsageView {
  return {
    storage: {
      usedBytes: res.current.storageBytes,
      totalBytes: res.limits.storageBytesTotal,
      perMailbox: res.perMailbox,
    },
    sending: {
      sentToday: res.current.sentToday,
      perDayMax: res.limits.sendPerDayMax,
      sentThisMonth: res.current.sentThisMonth,
    },
  };
}
